import { gql } from '@apollo/client';

export const ALL_SERVICE_PROVIDERS = gql`
  query AllServiceProviders($input: ExportArgs) {
    serviceProviders: allServiceProviders(input: $input) {
      id
      name
    }
  }
`;
